import { renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"overflow":"hidden"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    onBeforeEnter: _ctx.beforeEnter,
    onEnter: _ctx.enter,
    onAfterEnter: _ctx.afterEnter,
    onEnterCancelled: _ctx.enterCancelled,
    onBeforeLeave: _ctx.beforeLeave,
    onLeave: _ctx.leave,
    onAfterLeave: _ctx.afterLeave,
    onLeaveCancelled: _ctx.leaveCancelled,
    css: false
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ], 512), [
        [_vShow, _ctx.show]
      ])
    ]),
    _: 3
  }, 8, ["onBeforeEnter", "onEnter", "onAfterEnter", "onEnterCancelled", "onBeforeLeave", "onLeave", "onAfterLeave", "onLeaveCancelled"]))
}